import axios from 'axios';
import { req } from './axiosFun';

// 设备管理
export const device = (params) => { return req("post", "/api/saas/xht/device/device", params) };
export const addDevice = (params) => { return req("post", "/api/saas/xht/device/addDevice", params) };

export const bindDevice = (params) => { return req("post", "/api/saas/xht/device/bindDevice", params) };
export const unbindDevice = (params) => { return req("post", "/api/saas/xht/device/unbindDevice", params) };

// 空调伴侣
export const air = (params) => { return req("post", "/api/saas/xht/device/air", params) };
export const addAir = (params) => { return req("post", "/api/saas/xht/device/addAir", params) };
export const editAir = (params) => { return req("post", "/api/saas/xht/device/editAir", params) };

// 刷新门锁
export const lock = (params) => { return req("post", "/api/saas/xht/device/lock", params) };
export const refreshLock = (params) => { return req("post", "/api/saas/xht/device/refreshLock", params) };

export const editLock = (params) => { return req("post", "/api/saas/xht/device/editLock", params) };

// 设备划拨相关接口
export const transferDevice = (params) => { return req("post", "/api/saas/xht/device/transfer", params) };
export const getShopList = (params) => { return req("post", "/api/saas/xht/shop/shopList", params) };
export const batchOpen = (params) => { return req("post", "/api/saas/xht/device/batchOpen", params) };

//纷享智联、划拨设备获取店铺用户
export const fenxShop = (params) => { return req("post", "/api/work/fenx", params) };

export const fenxDevice = (params) => { return req("post", "/api/work/fenxDevice", params) };

export const QxiaShop = (params) => { return req("post", "/api/work/qxia", params) };

export const QxiaDevice = (params) => { return req("post", "/api/work/qxiaDevice", params) };

export const XcjcShop = (params) => { return req("post", "/api/work/xcjcShop", params) };

export const XcjcDevice = (params) => { return req("post", "/api/work/xcjcDevice", params) };



// WEBPACK FOOTER //
// ./src/api/device.js